import { compose, mapProps, withProps, withHandlers } from "recompact"
import get from "lodash/get"
import moment from "moment"
import withQueryParams from "src/hocs/withQueryParams"
import { DEFAULT_SCALE, SCALE_FROM_CODE, URL_DATE_FORMAT } from "../constants"

// Redirects to the such path where the time fits the plan's time range
export default compose(
  mapProps(props => ({ outerProps: props })),

  withQueryParams(),

  withHandlers({
    redirectTo: ({ queryApi: { push } }) => (date, scale) =>
      push(
        window.location.pathname.replace(
          /\/calendar\/?[^/]*\/?[^/]*/,
          `/calendar/${scale}/${date.format(URL_DATE_FORMAT)}`,
        ),
      ),
  }),

  withProps(
    ({
      redirectTo,
      outerProps: { plan, date, scale = SCALE_FROM_CODE[DEFAULT_SCALE] },
    }) => {
      const urlStart = moment(date, URL_DATE_FORMAT)
      const planStart = moment(get(plan, `data.startDateTime`)).startOf(scale)
      // The point of '- 1' is to set the end of the day last day,
      // not the start of the next day if the planEnd is 00:00
      const planEnd = moment(get(plan, `data.endDateTime`) - 1).endOf(scale)

      if (urlStart.isBefore(planStart) || urlStart.isAfter(planEnd)) {
        redirectTo(planStart, scale)
      }
    },
  ),

  mapProps(props => ({ ...props.outerProps })),
)
